export default __webpack_public_path__ + "static/media/icon.be8625ce.png";